import { render, staticRenderFns } from "./ItemDetailSuccess.vue?vue&type=template&id=3a9f3bc9&"
import script from "./ItemDetailSuccess.vue?vue&type=script&lang=ts&"
export * from "./ItemDetailSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports